import {StreamItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/stream.types';

interface Response {
  data?: {
    items?: StreamItem[] | undefined;
  };
}

export const useInitialStreamEmpty = (request: () => Response) => {
  return request().data?.items?.length === 0;
};
